import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TitleComponent } from '@shared/components/title';
import { TitleDescription } from '@shared/components/title-description/models';
import { HandleHtmlLinksDirective } from '@shared/directives';
import { ResponsiveService } from '@shared/services/responsive';

@Component({
  selector: 'app-title-description',
  imports: [TitleComponent, NgClass, HandleHtmlLinksDirective],
  templateUrl: './title-description.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleDescriptionComponent {
  titleDescription = input.required<TitleDescription>();
  readonly breakpoints = inject(ResponsiveService).breakpoints;
}
